import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-vrbo-wizard-step1',
  templateUrl: './connect-vrbo-wizard-step1.component.html',
  styleUrls: ['./connect-vrbo-wizard-step1.component.scss'],
})
export class ConnectVrboWizardStep1Component implements OnInit {
  @Output() next = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
